var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9459 8.33332C12.9459 9.94416 11.6401 11.25 10.0292 11.25C8.41842 11.25 7.11255 9.94416 7.11255 8.33332C7.11255 6.72249 8.41842 5.41666 10.0292 5.41666C11.6401 5.41666 12.9459 6.72249 12.9459 8.33332Z",
    stroke: "#8790A1",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 1.66666C6.31802 1.66666 3.33325 4.68151 3.33325 8.40057C3.33325 10.5271 4.16659 12.1806 5.83325 13.6575C7.00801 14.6985 9.14542 16.9316 9.99992 18.3332C10.8977 16.9595 12.9918 14.6985 14.1666 13.6575C15.8333 12.1806 16.6666 10.5271 16.6666 8.40057C16.6666 4.68151 13.6818 1.66666 9.99992 1.66666Z",
    stroke: "#8790A1",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.478b4908cc27237060c9d4bc749616ce.svg";
export { ForwardRef as ReactComponent };